'use client';
export { AccessibleIcon } from '@radix-ui/react-accessible-icon';
//# sourceMappingURL=accessible-icon.js.map